import { AgResourceLanguage } from '../types';
import { quiz as EnUsQuiz } from '../en-us/quiz';

export const quiz: AgResourceLanguage['quiz'] = {
  ...EnUsQuiz,
  landing: {
    ...EnUsQuiz.landing,
    headline: 'Découvrez si AG1 est fait pour vous',
    body: 'Le régime parfait n’existe pas, et il ne devrait pas être écrasant de trouver le bon supplément pour soutenir vos besoins nutritionnels quotidiens. Cliquez pour en savoir plus sur la façon dont AG1 peut vous accompagner dans votre parcours de santé.',
    bodySubtext: '',
    caption: 'Cet outil n’est pas destiné à diagnostiquer ou traiter une condition médicale',
    start: 'Commencez maintenant'
  },
  chart: {
    ...EnUsQuiz.chart,
    title: 'Commencez avec votre kit de bienvenue AG1 gratuit**',
    subtitle:
      'AG1 propose 75 vitamines, probiotiques et ingrédients alimentaires complets pour poser les bases de la santé mentale et physique sans compromettre la qualité.*'
  },
  tooltip: {
    title: 'LE SAVIEZ-VOUS ?'
  },
  ensureModal: {
    title: 'Toujours pas sûr ?',
    subtitle: 'Découvrez ce que les autres disent des avantages d’AG1',
    reviews: 'Lire les avis',
    reject: 'Non, merci'
  },
  processModal: {
    title: 'Recevez les dernières informations',
    subtitle:
      'En vous inscrivant aux actualités AG1, vous aurez accès aux meilleurs conseils, aux avis d’experts et aux informations les plus récentes sur la santé.',
    signUpText: 'Inscrivez-vous maintenant',
    signUpSuccess: 'Merci, vous êtes inscrit(e) !',
    signUpReject: 'Non, merci'
  },
  policy: {
    title:
      'En entrant votre adresse e-mail, vous acceptez de recevoir des communications marketing d’Athletic Greens et ces informations seront traitées conformément à notre',
    button: 'Politique de confidentialité'
  },
  valueChart: {
    title: 'Ressentez la puissance du Un',
    subtitle:
      'AG1 combine 75 ingrédients de haute qualité en une seule dose puissante, éliminant ainsi le besoin de suppléments uniques.',
    tableHead1: 'AG1 peut remplacer :',
    tableHead2: 'Coût par mois',
    chartConfig: [
      { title: 'Multivitamines et minéraux', value: 45 },
      { title: 'Probiotique', value: 30 },
      { title: 'Superaliments', value: 50 },
      { title: 'Adaptogène contre le stress', value: 30 },
      { title: 'Soutien immunitaire', value: 40 },
      { title: 'Soutien cognitif', value: 30 }
    ],
    tableFooter: 'Total par mois',
    caption:
      'Basé sur les données actuellement disponibles sur les prix moyens des suppléments premium dans l’industrie',
    buttonText: 'Continuez'
  },
  results: {
    button: 'Essayez AG1 maintenant'
  }
};
